import React, { memo } from 'react';
import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import { DropDownElement } from '../helpers/DropDown';
import Button from '../helpers/Button';
import AutoComplete from '../helpers/AutoComplete';
import BaseInput from '../helpers/Input';
import ErrorDisplay from '../decorators/DisplayError';
import PrettyError from '../decorators/PrettyError';
import { ContactFullNameRow } from './ContactFullNameRow';
import { EmailFinderField } from './EmailFinderField';
import Select from '../helpers/Select';

const Input = PrettyError(ErrorDisplay(BaseInput));

const renderSuggestion = suggest => <span>{suggest.text}</span>;

const AddLpContactPopup = props => {
  const {
    onChange,
    onLpChange,
    contact,
    lp,
    isValid,
    suggestRelation,
    onCreate,
    suggestSuffix,
    closable,
    submitting,
    onFindEmail,
  } = props;

  const prefix = contact.get('prefix');
  const prefixes = contact.get('prefixes');
  const suggestions = lp.get('suggests');

  const header = 'Create new LP profile';
  const onClickProps = submitting ? {} : { onClick: onCreate };
  const footer = (
    <Button {...onClickProps} className="btn-primary" disabled={!isValid} loading={submitting}>
      Create
    </Button>
  );

  const prefixesContent = prefixes.map((prefix, i) => {
    const attributes = prefix.get('attributes').toJS();

    return (
      <DropDownElement {...attributes} key={i} value={prefix.get('value')}>
        {prefix.get('name')}
      </DropDownElement>
    );
  });

  const statuses = lp.get('statuses');
  const status = lp.get('lpCurrentStatus');

  return (
    <Popup closable={closable} footer={footer} header={header} id="newExecProf">
      <div className="row">
        <AutoComplete
          checkOn="text"
          formGroupClass="col-md-6"
          getSuggestion={suggestRelation.onFetch}
          getSuggestionValue={suggestRelation.getValue}
          inputProps={{
            autoFocus: true,
            id: '2sitoveryyuolepopiup', // TODO remove this after autosuggest will not require id
            className: 'form-control',
            label: 'Relation',
            name: 'suggestRelation',
          }}
          onSuggestionSelected={suggestRelation.onSelect}
          onUpdateSuggestions={suggestRelation.onUpdate}
          renderSuggestion={renderSuggestion}
          suggestions={suggestions}
          text={suggestRelation.value}
        />
        <FormGroup className="col-md-6">
          <Select
            className="input-sm"
            id="f-current-status"
            label="Current Status"
            name="lpCurrentStatus"
            onChange={onLpChange}
            options={statuses}
            value={status}
            showLabel
          />
        </FormGroup>
      </div>

      <ContactFullNameRow
        onChange={onChange}
        prefix={prefix}
        prefixes={prefixesContent}
        root={contact}
        suffix={suggestSuffix}
      >
        <Input
          className="input-md"
          label="Full Name"
          name="fullName"
          onChange={onChange}
          placeholder="Full Name"
          root={contact}
          deep
          showLabel
        />
      </ContactFullNameRow>

      <div className="row">
        <FormGroup className="col-lg-6 col-sm-6">
          <Input
            className="input-md"
            label="First Name"
            name="firstName"
            onChange={onChange}
            placeholder="First Name"
            root={contact}
            deep
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-lg-6 col-sm-6">
          <Input
            className="input-md"
            label="Last Name"
            name="lastName"
            onChange={onChange}
            placeholder="Last Name"
            root={contact}
            deep
            showLabel
          />
        </FormGroup>
      </div>
      <div className="row">
        <FormGroup className="col-lg-6 col-sm-6">
          <Input label="Nick" name="nick" onChange={onChange} placeholder="Nick" root={contact} deep showLabel />
        </FormGroup>
        <FormGroup className="col-lg-6 col-sm-6">
          <Input
            label="Pronunciation"
            name="pronounce"
            onChange={onChange}
            placeholder="Pronunciation"
            root={contact}
            deep
            showLabel
          />
        </FormGroup>
      </div>
      <div className="row">
        <FormGroup className="col-lg-6 col-sm-6">
          <EmailFinderField onFindEmail={onFindEmail}>
            <Input
              className="input-sm"
              id="f-email3"
              label="Email"
              name="email"
              onChange={onChange}
              placeholder="Email"
              root={contact}
              type="emailVerify"
              deep
              required
              showLabel
            />
          </EmailFinderField>
        </FormGroup>
      </div>
    </Popup>
  );
};

export default memo(AddLpContactPopup);
